import { Stat, StatsWithGraph } from "@/components/marketing/sections/stats-with-graph"
import { PRODUCT_MODEL_STATS } from "@/content/marketing/site-content"

export function MarketingProductModelStats() {
  return (
    <StatsWithGraph
      id="model"
      eyebrow="How it is organized"
      headline="Behavioral facts, not a ticket backlog"
      subheadline={
        <p>
          Jira, ClickUp, and Linear are ticket-centric: close enough tickets and the actual truth about your
          product has to be reconstructed from scattered docs and tribal knowledge. ArtlessDev is organized
          around scenarios instead — durable statements about what your software actually does, not
          disposable tasks that get closed and forgotten. The app tracks whether each one still matches reality;
          the scenario's content stays the source of truth.
        </p>
      }
    >
      {PRODUCT_MODEL_STATS.map((item) => (
        <Stat key={item.stat} stat={item.stat} text={item.text} />
      ))}
    </StatsWithGraph>
  )
}
